export default __webpack_public_path__ + "static/media/arrow-down.1d359caa.svg";